export enum UserJobTitleEnum {
  CO_FOUNDER = "Co-Founder",
  CEO = "CEO",
  CTO = "CTO",
  CFO = "CFO",
  FINANCE_MANAGER = "Finance Manager",
  ACCOUNTING_MANAGER = "Accounting Manager",
  OTHER = "Other",
  SECRETARY = "Secretary",
  TREASURER = "Treasurer",
}

export const JOB_TITLES: string[] = Object.values(UserJobTitleEnum);

// Translation function for job titles
export const getJobTitleTranslation = (t: any, jobTitle: string): string => {
  return t(`jobTitles.${jobTitle}`, { defaultValue: jobTitle });
};

export enum DirectorsJobTitleEnum {
  CEO = "CEO",
  CFO = "CFO",
  CTO = "CTO",
  COO = "COO",
  PRESIDENT = "President",
  ACCOUNTING_MANAGER = "Accounting Manager",
  FINANCE_MANAGER = "Finance Manager",
  TREASURER = "Treasurer",
  SECRETARY = "Secretary",
  DIRECTOR = "Director",
  OTHER = "Other",
  CO_FOUNDER = "Co-Founder",
}

export const DIRECTOR_JOB_TITLES: string[] = Object.values(DirectorsJobTitleEnum);

// Translation function for director job titles
export const getDirectorJobTitleTranslation = (t: any, jobTitle: string): string => {
  return t(`jobTitles.${jobTitle}`, { defaultValue: jobTitle });
};
